String.prototype.reverse = function(){
  return this.split("").reverse().join("");
};

String.prototype.toIndonesianNumber = function(){
  return this.reverse().match(/.{1,3}/g).join(".").reverse();
};

String.prototype.shortenNumber = function(){
  const symbols = [
    { value: 1, symbol: "" },
    { value: 1E3, symbol: "K" },
    { value: 1E6, symbol: "M" },
    { value: 1E9, symbol: "B" },
  ];
  let i;
  let intNum = parseInt(this.replace(/\./g,''));

  if(isNaN(intNum)) {
    return "";
  }

  for (i = symbols.length - 1; i > 0; i--) {
    if (intNum >= symbols[i].value) {
      break;
    }
  }

  const number = intNum / symbols[i].value;
  const with1Decimal = number.toString().match(/^-?\d+(?:\.\d{0,1})?/)[0];
  return with1Decimal + symbols[i].symbol;
};
